import type { App, Plugin } from "vue";
import type { Router } from "vue-router";
import { useFeatureFlagsStore } from "@/stores/feature-flags-store.ts";

class FeatureFlagsService {
  private readonly router: Router;

  constructor(router: Router) {
    this.router = router;
  }

  init(): void {
    this.router.beforeEach((to) => {
      const featureFlagsStore = useFeatureFlagsStore();

      featureFlagsStore.ingestFromQuery(to.query);

      return true;
    });
  }
}

export const FeatureFlagsPlugin: Plugin = {
  install(_app: App, router: Router) {
    const service = new FeatureFlagsService(router);

    service.init();
  },
};
